import { barcodeLabelSize } from "@redotech/redo-model/inventory/barcode-label";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const printBarcodeForProduct = {
  name: "printBarcodeForProduct" as const,
  input: z.object({
    productId: productIdFormat.schema,
    labelSize: z.enum(barcodeLabelSize).optional(),
    printerId: z.number().optional(),
    printInventoryLabel: z.boolean().optional(),
    print3plLabel: z.boolean().optional(),
  }),
  output: z.object({
    inventoryPdfDataUrl: z.string().optional(),
    threePlPdfDataUrl: z.string().optional(),
    productId: productIdFormat.schema,
    sku: z.string().nullable(),
    barcodeValue: z.string(),
  }),
};
